import { type OrganizationList, isChurch } from 'models';
import { useCallback } from 'react';
import { Icon } from 'ui';

export const useGetOrganizationIcon = () =>
  useCallback(
    ({ organization }: { organization: OrganizationList }) =>
      isChurch({ organization }) ? <Icon icon="church-line" /> : <Icon icon="bank-line" />,
    [],
  );
